import React from 'react';

import useScrollTo from '../../hooks/useScrollTo';
import useTranslation from '../../hooks/useTranslation';

import { useLayoutState } from '../../layout/Context';

import Reveal from '../Reveal';
import Typography from '../Typography';

const Menu = () => {
  const { locale, aboutRef, expoRef, contactsRef } = useLayoutState();

  const scrollToAbout = useScrollTo(aboutRef);
  const scrollToExpo = useScrollTo(expoRef);
  const scrollToContacts = useScrollTo(contactsRef);

  const { t } = useTranslation('navigation', locale);

  return (
    <div className="flex justify-end gap-x-8 text-black">
      <Reveal>
        <button
          type="button"
          onClick={scrollToAbout}
        >
          <Typography as="span">
            {t('About')}
          </Typography>
        </button>
      </Reveal>
      <Reveal>
        <button
          type="button"
          onClick={scrollToExpo}
        >
          <Typography as="span">
            {t('Exposition')}
          </Typography>
        </button>
      </Reveal>
      <Reveal>
        <button
          type="button"
          onClick={scrollToContacts}
        >
          <Typography as="span">
            {t('Contacts')}
          </Typography>
        </button>
      </Reveal>
    </div>
  );
}

export default Menu;
